module.exports = "<app-datagrid class=\"reporting-live-grid\" [columnDefs]=\"columnDefs\" [rowData]=\"data\" [gridOptions]=\"gridOptions\">\n</app-datagrid>"